<template>
  <div class="phone-keypad">
    <div class="phone-number-container">
      <div class="phone-number">
        <span v-for="(char, index) in placeholderArray" :key="index" :class="{ filled: displayMobileNumber[index] }">
          {{ displayMobileNumber[index] || char }}
        </span>
      </div>
      <button class="password-button" @click="toggleVisibility">
        <img v-show="showMobileNumber" src="@/assets/images/icon-open-eye.png" alt="비밀번호 보기 아이콘" />
        <img v-show="!showMobileNumber" src="@/assets/images/icon-close-eye.png" alt="비밀번호 숨기기 아이콘" />
      </button>
    </div>
    <BaseKeypad v-model="internalValue" :max-length="11" />
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import BaseKeypad from './BaseKeypad.vue';

  const modelValue = defineModel<string>({ default: '010' });

  // 내부 조작을 위한 computed (010 강제 유지)
  const internalValue = computed({
    get: () => modelValue.value,
    set: (val) => {
      // 입력값이 '010'으로 시작하지 않거나 3자 미만이면 '010'으로 고정
      if (!val.startsWith('010')) {
        modelValue.value = '010';
      } else {
        modelValue.value = val;
      }
    },
  });

  const placeholderArray = '010-0000-0000'.split('');
  const showMobileNumber = ref(false);

  const displayMobileNumber = computed(() => {
    const num = modelValue.value.replace(/\D/g, ''); // 숫자만 추출

    // 포맷팅 로직 (010-XXXX-XXXX)
    let formatted = '';
    if (num.length <= 3) {
      formatted = num;
    } else if (num.length <= 7) {
      formatted = `${num.slice(0, 3)}-${num.slice(3)}`;
    } else {
      formatted = `${num.slice(0, 3)}-${num.slice(3, 7)}-${num.slice(7)}`;
    }

    // 마스킹 처리 (010 이후 번호만 마스킹)
    if (!showMobileNumber.value) {
      return formatted
        .split('')
        .map((char, i) => {
          // 숫자이면서 index가 3(하이픈 제외 010 이후)보다 크면 '*' 처리
          return /\d/.test(char) && i > 3 ? '*' : char;
        })
        .join('');
    }

    return formatted;
  });

  const toggleVisibility = () => {
    showMobileNumber.value = !showMobileNumber.value;
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .phone-keypad {
    display: grid;
    grid-template-rows: auto 1fr;
    gap: 1.5625vw;
    width: 100%;
    height: 100%;
    @media (max-width: vars.$sm) {
      gap: 20px;
    }

    .phone-number-container {
      position: relative;
      display: grid;
      grid-template-columns: 1fr auto;
      padding: 0 0.7813vw;
      border-bottom: 1px solid #989898;

      .phone-number {
        color: #ccc;
        font-size: 3.75vw;
        font-weight: 600;
        @media (max-width: vars.$sm) {
          font-size: 32px;
        }

        span {
          display: inline-block;
          width: 1.1ch;
          text-align: center;

          &.filled {
            color: #000;
          }
        }
      }

      .password-button {
        padding: 0 0.3906vw;
        border: none;
        background-color: unset;
        img {
          width: 4.6875vw;
          @media (max-width: vars.$sm) {
            width: 40px;
          }
        }
      }
    }
  }
</style>
